import { useContext } from "react";
import CaseContext from "../context/CaseContext";

const useCases = () => {
	return useContext(CaseContext);
};

export default useCases;
